export const SET_QUERY = "SET_QUERY";
export const SET_QUESTS = "SET_QUESTS";
export const SET_SKYLIFTS = "SET_SKYLIFTS";
export const SET_COMMUNITIES = "SET_COMMUNITIES";
export const SET_ORGANIZATION = "SET_ORGANIZATION";
export const SET_LISTED_JOBS = "SET_LISTED_JOBS";
export const SET_USERS = "SET_USERS";
export const SET_MENTORS = "SET_MENTORS";
export const RESET_SEARCH_RESULTS = "RESET_SEARCH_RESULTS";
export const SET_IS_NAV_SEARCH_BAR_IN_FOCUS = "SET_IS_NAV_SEARCH_BAR_IN_FOCUS";
export const SET_IS_BANNER_SEARCH_BAR_IN_FOCUS =
  "SET_IS_BANNER_SEARCH_BAR_IN_FOCUS";
export const SET_SEARCH_BAR_RESULTS = "SET_SEARCH_BAR_RESULTS";
export const RESET_SEARCH_BAR = "RESET_SEARCH_BAR";
